import { type Post, type PostDto } from '../model/contracts'

export function toPost(dto: PostDto): Post {
  return { ...dto, key: dto.url }
}

export function dedupePostsByKey(posts: readonly Post[]): Post[] {
  const seen = new Set<string>()
  const out: Post[] = []
  for (const p of posts) {
    if (seen.has(p.key)) continue
    seen.add(p.key)
    out.push(p)
  }
  return out
}

export function sortPostsByTimestampDesc(posts: readonly Post[]): Post[] {
  return [...posts].sort((a, b) => {
    const at = Date.parse(a.timestamp)
    const bt = Date.parse(b.timestamp)
    return (Number.isFinite(bt) ? bt : 0) - (Number.isFinite(at) ? at : 0)
  })
}
